<template>
  <div
    v-tooltip="options"
    class="button"
    :class="['cursor-toggle', { 'grab-on': isCursorGrab }]"
    @click="toggleCursor"
  >
    <svg-icon
      :width="'23'"
      :height="'20'"
      icon="app-icons/hand"
      :fill="isCursorGrab ? '#fff' : '#bcbcbc'"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { PANZOOM } from '@/constants';
import SvgIcon from '../all/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },

  data() {
    return {
      options: {
        content: 'Toggle select/pan mode',
        placement: 'top',
        distance: 20,
        delay: { show: 800, hide: 0 },
      },
    };
  },

  computed: {
    ...mapGetters('project/config', ['getCursorMode']),
    isCursorGrab() {
      return this.getCursorMode === PANZOOM.CURSOR_MODE.GRAB;
    },
  },

  methods: {
    ...mapActions('project/config', ['setCursorMode']),

    toggleCursor() {
      console.log('TOGGLE CURSOR CLICKED');
      if (this.getCursorMode === PANZOOM.CURSOR_MODE.GRAB) {
        this.setCursorMode({ value: PANZOOM.CURSOR_MODE.SELECT, apply: true });
      } else {
        this.setCursorMode({ value: PANZOOM.CURSOR_MODE.GRAB, apply: true });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.cursor-toggle {
  position: relative;
  left: -2px;
}
</style>
